export default __webpack_public_path__ + "resources/icons/n322-3d9d.webp";